import React, { useState } from 'react';
import { Modal, SearchableSelect } from '../../components/ui';
import { errMsg } from '../../utils/format';
import { useFetch } from '../../hooks/useFetch';
import api from '../../utils/api';

export default function AddWorkOrderModal({ onClose, onSaved }) {
  const { data: boms } = useFetch('/api/bom');
  const [form, setForm] = useState({ productId:'', quantity:'', startDate:'', notes:'' });
  const [saving, setSaving] = useState(false);

  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  // Only show products that have a BOM defined
  const productOptions = (boms || []).map(b => ({
    value: b.product_id,
    label: `${b.sku} — ${b.product_name}`
  }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post('/api/work-orders', { ...form, productId: parseInt(form.productId), quantity: parseInt(form.quantity) });
      onSaved('Work order created successfully'); onClose();
    } catch(err) { alert(errMsg(err)); }
    finally { setSaving(false); }
  };

  return (
    <Modal title="New Work Order" onClose={onClose}
      footer={<><button className="btn" onClick={onClose}>Cancel</button><button className="btn btn-primary" form="add-wo-form" type="submit">{saving?'Saving…':'Create work order'}</button></>}>
      <form id="add-wo-form" onSubmit={save}>
        <div className="form-group">
          <label>Product to produce *</label>
          <SearchableSelect
            value={form.productId}
            onChange={v => set('productId', v)}
            options={productOptions}
            placeholder="— Search products with BOM —"
          />
        </div>
        <div className="form-row">
          <div className="form-group"><label>Quantity to produce *</label><input type="number" required min="1" value={form.quantity} onChange={e=>set('quantity',e.target.value)} /></div>
          <div className="form-group"><label>Start date</label><input type="date" value={form.startDate} onChange={e=>set('startDate',e.target.value)} /></div>
        </div>
        <div className="form-group"><label>Notes</label><textarea value={form.notes} onChange={e=>set('notes',e.target.value)} /></div>
      </form>
    </Modal>
  );
}
